import { appContext } from '../../../../AppContext';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { JSX } from 'react';
import { IState as IParentState } from './EditUser';
import { SerendieSymbol } from '@serendie/symbols';
import { Card, GridContainer, GridItem, OnSectionUpdateHandler, TextField } from '@iconics/components';

class EditUserDetails extends IbssComponent<IProps, IState>
{

    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    }

    public render(): JSX.Element
    {
        return (
            <Card
                icon={<SerendieSymbol name='user' />}
                title={this.labels.Platform_User_DetailsTitle}
                subTitle={this.labels.Platform_User_DetailsSubTitle}
                onSectionUpdate={i => this.props.onSectionUpdate(i)}
            >
                <GridContainer>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_Email}
                            placeholder={this.labels.User_Email}
                            value={this.props.email}
                            onChange={(e) => this.props.handleInputChange('email', e.target.value)}
                            required
                            invalid={!!this.props.emailError}
                            invalidMessage={this.props.emailError}
                            disabled={!this.props.isNew && !this.props.isNative}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_DisplayName}
                            placeholder={this.labels.User_DisplayName}
                            value={this.props.displayName}
                            required
                            invalid={!!this.props.displayNameError}
                            invalidMessage={this.props.displayNameError}
                            onChange={(e) => this.props.handleInputChange('displayName', e.target.value)}
                            disabled={!this.props.isNew && !this.props.isNative}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_FirstName}
                            placeholder={this.labels.User_FirstName}
                            value={this.props.firstName}
                            required
                            invalid={!!this.props.firstNameError}
                            invalidMessage={this.props.firstNameError}
                            onChange={(e) => this.props.handleInputChange('firstName', e.target.value)}
                            disabled={!this.props.isNew && !this.props.isNative}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_LastName}
                            placeholder={this.labels.User_LastName}
                            value={this.props.lastName}
                            required
                            invalid={!!this.props.lastNameError}
                            invalidMessage={this.props.lastNameError}
                            onChange={(e) => this.props.handleInputChange('lastName', e.target.value)}
                            disabled={!this.props.isNew && !this.props.isNative}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_PreferredName}
                            placeholder={this.labels.User_PreferredName}
                            value={this.props.preferredName}
                            onChange={(e) => this.props.handleInputChange('preferredName', e.target.value)}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_Initials}
                            placeholder={this.labels.User_Initials}
                            value={this.props.initials}
                            onChange={(e) => this.props.handleInputChange('initials', e.target.value)}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_PhoneNumber}
                            placeholder={this.labels.User_PhoneNumber}
                            value={this.props.phoneNumber}
                            onChange={(e) => this.props.handleInputChange('phoneNumber', e.target.value)}
                            disabled={!this.props.isNew && !this.props.isNative}
                        />
                    </GridItem>
                    <GridItem expanded={6}>
                        <TextField
                            label={this.labels.User_UserLocation}
                            placeholder={this.labels.User_UserLocation}
                            value={this.props.location}
                            onChange={(e) => this.props.handleInputChange('location', e.target.value)}
                            disabled={!this.props.isNew && !this.props.isNative}
                        />
                    </GridItem>
                </GridContainer>
            </Card>
        )
    }
}

export default EditUserDetails;

export interface IProps
{
    email: string;
    emailError: string;
    preferredName: string;
    firstName: string;
    lastName: string;
    displayName: string;
    firstNameError: string;
    lastNameError: string;
    displayNameError: string;
    initials: string;
    phoneNumber: string;
    location: string;
    isNew: boolean;
    isNative: boolean;
    handleInputChange: (fieldName: keyof IParentState, value: IParentState[keyof IParentState]) => void
    onSectionUpdate: OnSectionUpdateHandler;
}

export interface IState 
{

}